import { DerechoNested, Dimension, FlattenedData, TipoIndicador } from "../interfaces/OpenData";
import { INDICATOR_TYPE_STRUCTURAL } from "./const";

export function flattenRightsData(derechosAnidados: any[]): FlattenedData {
    const derechos: DerechoNested[] = [];
    const tiposIndicadoresMap = new Map<string, TipoIndicador>();
    const dimensionesMap = new Map<string, Dimension>();

    derechosAnidados.forEach(derecho => {
        // Agregar derecho (sin tipos_indicadores)
        derechos.push({
            id: derecho.id,
            titulo: derecho.titulo,
            count: derecho.count,
            disabled: false,
            tipos_indicadores: derecho.tipos_indicadores
        });

        // Procesar tipos de indicadores
        derecho.tipos_indicadores?.forEach((tipo: any) => {
            if (tiposIndicadoresMap.has(tipo.titulo)) {
                const existente = tiposIndicadoresMap.get(tipo.titulo)!;
                existente.count += tipo.count;
            } else {
                tiposIndicadoresMap.set(tipo.titulo, {
                    id: tipo.id,
                    titulo: tipo.titulo,
                    count: tipo.count
                });
            }

            // Procesar dimensiones
            tipo.dimensiones?.forEach((dimension: any) => {
                const key = dimension.titulo;

                if (dimensionesMap.has(key)) {
                    const existente = dimensionesMap.get(key)!;
                    existente.count += dimension.count;

                    if (!existente.derechosIds?.includes(derecho.id)) {
                        existente.derechosIds = [...(existente.derechosIds || []), derecho.id];
                        existente.derechosTitulos = [...(existente.derechosTitulos || []), derecho.titulo];
                    }
                } else {
                    dimensionesMap.set(key, {
                        id: dimension.id,
                        titulo: dimension.titulo,
                        count: dimension.count,
                        derechosIds: [derecho.id],
                        derechosTitulos: [derecho.titulo],
                        disabled: false
                    });
                }
            });
        });
    });

    if (!tiposIndicadoresMap.has(INDICATOR_TYPE_STRUCTURAL)) {
        tiposIndicadoresMap.set(INDICATOR_TYPE_STRUCTURAL, {
            id: 3,
            titulo: INDICATOR_TYPE_STRUCTURAL,
            count: 0,
            disabled: true
        });
    }

    const tiposIndicadores = Array.from(tiposIndicadoresMap.values());
    const dimensiones = Array.from(dimensionesMap.values());

    return { derechos, tiposIndicadores, dimensiones };
}